import InstallNodePackageManagers from "../../../../contents/docs/integrate/_snippets/install-node-package-managers.mdx";
import Tab from "components/Tab";
import AppRouterServerSetup from "../../../../contents/docs/integrate/_snippets/nextjs/app-router-server-setup.mdx";
import PagesRouterServerSetup from "../../../../contents/docs/integrate/_snippets/nextjs/pages-router-server-setup.mdx";
import * as React from 'react';
export default {
  InstallNodePackageManagers,
  Tab,
  AppRouterServerSetup,
  PagesRouterServerSetup,
  React
};